<template>
  <div class="zixunBox">
    <h3>咨询类短案件管理</h3>
    <div class="searchBox">
      <div class="block">
        时间
        <el-date-picker v-model="startTime" value-format="timestamp" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" size="mini">
        </el-date-picker>
      </div>
      <div class="block">
        报案人
        <el-input class='width' placeholder="请输入报案人" size="mini" v-model="reportUser"></el-input>
      </div>
      <div class="block">
        案件号
        <el-input class='width' placeholder="请输入案件号" size="mini" v-model="caseNo"></el-input>
      </div>
      <div class="block">
        <el-button type="primary" @click="getOrdinaryCaseGoing()" size="mini">查询</el-button>
      </div>
    </div>
    <div class="table">
      <table width="100%" border="0" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th v-for="item in tableName" v-if="$route.query.status != 3">{{item}}</th>
            <th v-for="item in tableName3" v-if="$route.query.status == 3">{{item}}</th>
          </tr>
        </thead>
        <tbody v-if="zxList.length != 0">
          <tr v-for="(item,index) in zxList">
            <td>{{index + 1}}</td>
            <td>{{item.obj.reportUser}}</td>
            <td>{{item.obj.reporterContact}}</td>
            <td>{{formattingTime(item.obj.reportTs)}}</td>
            <td>{{item.victimList[0].obj.victimName}}</td>
            <td>{{setTxt(item.generalLocation.addr)}}</td>
            <td>{{item.obj.caseInsured == 2 ? '无保':'在保'}}</td>
            <td>{{item.obj.caseSrc}}</td>
            <td v-if="$route.query.status != 3">{{formattingTime(item.obj.updateAt)}}</td>
            <td v-if="$route.query.status == 3">{{formattingTime(item.obj.lastCheckPtsTs)}}</td>
            <td v-if="$route.query.status == 3">{{item.obj.closeText}}</td>
            <td width="18%" v-if="$route.query.status == '1'">
              <router-link :to="{name:'creatCase1',query:{caseId:item.obj.id,status:1}}">案件信息</router-link>
              <a @click="dialogVisible= true;closeId=item.obj.id">完成案件</a>
            </td>
            <td width="18%" v-else>
              <router-link :to="{name:'creatCase1',query:{caseId:item.obj.id,status:2}}">案件信息</router-link>
            </td>
          </tr>
        </tbody>

      </table>
      <p v-if="zxList.length == 0" class="noRecord">暂无记录</p>
    </div>
    <el-dialog title="是否确认完成案件？" :visible.sync="dialogVisible" width="30%" style="margin-top: 200px;">
      <span>完成后不可修改案件任何信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false;closeOrdinaryCase(closeId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getOrdinaryCaseGoing,
    getfinishCase,
    list_closed_case
  } from '@/views/axios/api.js';
  import constants from "@/util/constants.js"
  export default {
    data() {
      return {
        startTime: null,
        dialogVisible: false,
        tableName: ['序号', '报案用户', '用户手机号', '报案时间', '出险人', '出险地', '出险人保障', '案件来源', '确认时间','操作'],
        tableName3: ['序号', '报案用户', '用户手机号', '报案时间', '出险人', '出险地', '出险人保障', '案件来源', '关闭时间','备注','操作'],
        zxList: [],
        closeId: '',
        token: JSON.parse(window.localStorage.getItem("data")).data,
        caseNo: '',
        reportUser: ''
      }
    },
    mounted() {
      this.getOrdinaryCaseGoing()
    },
    methods: {
      setTxt(str, status) {
      	if (constants.setTxt(str, status)) {
      		return constants.setTxt(str, status);
      	} else {
      		return str;
      	}
      },
      formattingTime(time) {
        return constants.time(time)
      },
      getOrdinaryCaseGoing() {
        var state = '';
        if (this.$route.query.status == 1) {
          state = 80;
        } else if(this.$route.query.status == 2){
          state = 110;
        }else {
          state = 116;
        }
        var data={}
        if(this.$route.query.status ==3) {
          if (this.startTime == null) {
           data = {
            token: this.token,
            status:state,
            start: 0,
            count: 100,
            reportUser: this.reportUser,
            caseNo: this.caseNo
          }
        }else{
           data = {
            token: this.token,
            status:state,
            begin: this.startTime[0],
            end: this.startTime[1],
            start: 0,
            count: 100,
            reportUser: this.reportUser,
            caseNo: this.caseNo
          }
        }
        }else {
          if (this.startTime == null) {
           data = {
            token: this.token,
            state,
            start: 0,
            count: 100,
            reportUser: this.reportUser,
            caseNo: this.caseNo
          }
        }else{
           data = {
            token: this.token,
            state,
            begin: this.startTime[0],
            end: this.startTime[1],
            start: 0,
            count: 100,
            reportUser: this.reportUser,
            caseNo: this.caseNo
          }
        }
        }
        
        
        if(this.$route.query.status == 3) {
          list_closed_case(data)
          .then(res => {
            this.zxList = res.data.obj
          })
          .catch(err => {
            console.log(err)
          })
        }else {
          getOrdinaryCaseGoing(data)
          .then(res => {
            this.zxList = res.data.obj
          })
          .catch(err => {
            console.log(err)
          })
        }
     
      },
      closeOrdinaryCase(caseId) {
        getfinishCase({
            caseId,
		token:this.token
          })
          .then(res => {
            console.log(res)
            this.getOrdinaryCaseGoing()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    watch: {
      $route(to) {
        this.numBtn = this.$route.query.status
        this.getOrdinaryCaseGoing()
      },
      numBtn() {
        this.getOrdinaryCaseGoing()
      }
    }
  }
</script>

<style scoped="scoped">
  .zixunBox h3 {
    margin-top: 20px;
  }

  .table {
    margin-top: 30px;
    border: 1px solid #d9ddde;
    border-right: none;
    border-bottom: none;
  }

  .table thead {
    background: #f5f7fb;
    color: #333;
  }

  .table th {
    font-size: 14px;
    color: #333;
    height: 50px;
    border-bottom: 1px solid #d9ddde;
    border-right: 1px solid #d9ddde;
  }

  .table td {
    border-bottom: 1px solid #d9ddde;
    border-right: 1px solid #d9ddde;
    text-align: center;
    font-size: 12px;
    height: 50px;
    word-wrap: break-word;
    padding: 0 5px
  }

  .table a {
    text-decoration: none;
    color: #00abfa;
    padding: 0 5px;
    cursor: pointer;
  }

  .noRecord {
    text-align: center;
    line-height: 100px;
    border-right: 1px solid #d9ddde;
    color: #666;
    border-bottom: 1px solid #d9ddde;
  }

  .searchBox {
    margin-top: 20px;
  }

  .searchBox>div {
    display: inline-block;
    margin-right: 20px;
  }

  .width {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/views/cmd_center/monitoringCase/consulting.vue